import { Component } from 'react';
import styled from 'styled-components';
import { fontSize } from '../../../../../common/css/setting/variable';
import { IConvertedImages } from '../../../../../common/store/interface/IConvertedImages';
import LabelIcon from '../modules/LabelIcon';
import { ImageSizeConstants, Thumbnail } from '@/public/template/common/ThumbnailV2';

interface IProps {
  readonly headline: string;
  readonly mediaName: string;
  readonly newsLink: string;
  readonly isPay: boolean;
  readonly hasVideo: boolean;
  readonly duration?: string;
  readonly thumb: {
    readonly width: number;
    readonly height: number;
    readonly url: string;
  };
  readonly resizedThumbUrl: IConvertedImages | null;
  readonly dateString: string;
  readonly timeString: string;
  readonly rankingNumber: number | null;
  readonly ultSec: string;
}

const ListItem = styled.li`
  line-height: 1.3;
  border-bottom: solid 1px ${props => props.theme.news.palette.bor_lv2_pc};
`;

const LabelIconWrapper = styled.span`
  margin-left: 4px;
  font-size: 0; /* 縦を揃える */
  vertical-align: middle;
`;

const ThumbnailWrapper = styled.div`
  margin-left: 8px;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
`;

const RankNumber = styled.span`
  display: block; /* IE10で崩れるのでdisplay: block;を指定 */
  flex-shrink: 0;
  width: 30px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: ${fontSize.px18};
  font-weight: bold;
  color: ${props => props.theme.news.palette.text_base_common};
  text-align: center;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

const ArticleTextWrapper = styled.div`
  flex: 1;
`;

const ArticleTitle = styled.p`
  padding: 0 0 4px;
  font-size: ${fontSize.px13};
`;

const ArticleSubText = styled.div`
  font-size: ${fontSize.px12};
  color: ${props => props.theme.news.palette.text_sub_lv1_common};
`;

const MediaName = styled.span`
  margin-right: 4px;
`;

const DateTimeText = styled.span`
  display: inline-block;
  margin-right: 4px;
`;

const Link = styled.a`
  display: block;
  padding: 8px 0;

  &:visited {
    color: ${props => props.theme.news.palette.link_visited_pc};
  }

  &:hover {
    text-decoration: none;
    background-color: ${props => props.theme.news.palette.bg_hover_subColumn_pc};

    ${ArticleTitle} {
      color: ${props => props.theme.news.palette.link_hover_pc};
      text-decoration: underline;
    }
  }
`;

export default class RankingItem extends Component<IProps> {
  /**
   *
   */
  public render() {
    const video =
      this.props.hasVideo && this.props.duration
        ? ({ hasVideo: true, videoDuration: this.props.duration } as const)
        : ({ hasVideo: false } as const);

    const payIcon = this.props.isPay ? (
      <LabelIconWrapper>
        <LabelIcon type="PAY" />
      </LabelIconWrapper>
    ) : null;

    return (
      <ListItem key={this.props.newsLink}>
        <Link
          href={this.props.newsLink}
          data-cl-params={`_cl_vmodule:${this.props.ultSec};_cl_link:title;_cl_position:${this.props.rankingNumber};`}
        >
          <Wrapper>
            {this.props.rankingNumber !== null && <RankNumber>{this.props.rankingNumber}</RankNumber>}
            <ContentsWrapper>
              <ArticleTextWrapper>
                <ArticleTitle>{this.props.headline}</ArticleTitle>
                <ArticleSubText>
                  <MediaName>{this.props.mediaName}</MediaName>
                  <time>
                    <DateTimeText>{this.props.dateString}</DateTimeText>
                    <DateTimeText>{this.props.timeString}</DateTimeText>
                  </time>
                  {payIcon}
                </ArticleSubText>
              </ArticleTextWrapper>
              {this.props.thumb.url !== '' && (
                <ThumbnailWrapper>
                  <Thumbnail
                    size={ImageSizeConstants.PC_SMALL}
                    src={this.props.resizedThumbUrl ?? this.props.thumb.url}
                    {...video}
                  />
                </ThumbnailWrapper>
              )}
            </ContentsWrapper>
          </Wrapper>
        </Link>
      </ListItem>
    );
  }
}
